<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">
  
  <div class="content-section">
    <h2>Assurance Moto - Scooter - Cyclo - Vespa Professionnelle</h2>
    <p>
      Vous êtes un motard conducteur d'un 2 roues de l'entreprise et vous recherchez une assurance moto professionnelle, mais vous ne trouvez pas d'assureur ? 
      BROKINS vous trouve l'assurance qu'il vous faut au prix le plus juste.
    </p>
    <p>
      <strong>Contactez-nous !</strong>
    </p>
    <p>
      Par ailleurs, nous avons de nombreux partenaires spécialisés dans les cas difficiles notamment dit les RISQUES AGGRAVÉS : 
      Malus de 3.5, Stupéfiants, Alcoolémie, Annulation de permis, suspension de permis, résilié compagnie, non-paiement, sanction judiciaire, jeune conducteur, sans antécédent….
    </p>
    <p>
      Si le 2 roues a été acheté sur les fonds privés, ou si le nom de la société n'apparait pas sur la carte grise de la moto ou du scooter, alors il vous sera possible de souscrire à 
      une <a href="/assurance-moto-personnelle">Assurance Moto Personnelle</a>.
    </p>
  </div>

  <div class="content-section bg-accent">
    <h2>DES AVANTAGES EXCLUSIFS :</h2>
    <ul class="advantages-list">
      <li>Larges critères de souscription : résilié compagnie, malusé, suspension ou annulation de permis, non-paiement, alcoolémie,</li>
      <li>Garantie sécurisation du permis incluse dès la formule de base.</li>
      <li>Assistance 0 km et véhicule de remplacement en option.</li>
      <li>Souscription et carte verte immédiates.</li>
      <li>Règlement mensuel possible y compris pour les non paiements de prime.</li>
      <li>Réduction automatique de 50% sur la franchise dommage après 12 mois d'assurance sans sinistre responsable.</li>
      <li>Paiement du stage permis.</li>
      <li>Jusqu'à 8 000 € de prise en charge en cas de dommages causés sur les équipements vestimentaires et accessoires hors-série (bottes, combinaison, blouson, pantalon, gilet et pantalon airbag, top-case, valises…).</li>
      <li>Une suspension des garanties : Mauvais temps ? Voyage prolongé ? Arrêt maladie ? Grâce à l'option suspension des garanties vous pouvez suspendre les garanties de circulation 
          lorsque la moto est au garage et ainsi bénéficier d'une réduction de leur prime allant jusqu'à 30%.</li>
    </ul>
  </div>

  <div class="content-section">
    <p>
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est listé ci-dessous : 
      <strong>GENERALI, APRIL, AMV, MUTUELLE DES MOTARDS, FMA, NOVELIA SURAVENIR, NETVOX, ZEPHIR, XENASSUR, PROGEAS</strong>.
    </p>
  </div>
</app-page-layout>
